import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ArticleForm from './ArticleForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditArticleModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( { article, tags } ) => {
        this.setState( { fetching: true } );
        article.tagIds = tags;
        this.props.updateArticle( article.id, article )
        .then( ( newArticle ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newArticle );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteArticle = () => {
        this.setState( { fetching: true } );
        this.props.deleteArticle( this.props.article.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }


    render() {
        const { article } = this.props;

        var initialValues = {
            ...article,
            interestId: ( article.interests || [ {interestid: null} ] ).map( interest => interest.interestid )[0],
            rankedArticle: !!article.featured,
        };

        return (
            <DLModal title='Edit Content'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ArticleForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS ARTICLE?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteArticle }>
                            DELETE ARTICLE
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS ARTICLE
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateArticle: ( id, data ) => {
            return dAPI.patch( `/admin/content/${ id }`, data );
        },
        deleteArticle: ( id ) => {
            return dAPI.delete( `/admin/curated-articles/${ id }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditArticleModal );
